// Import only the specific submodules needed instead of full barrel exports
// to avoid pulling in unused code (auth UI, shared-services predict/orgs/billing, etc.)
import { authReducers } from '@futrli/auth/core/root-reducer';
import { SIGN_OUT } from '@futrli/auth/login/constants';
import { intlReducer } from '@futrli/localisation';
import { appAuthenticator } from '@futrli/shared-services/app-core/setup/app-authenticator';
import { appSigner } from '@futrli/shared-services/app-core/setup/app-signer';
import { axiosBaseInstance } from '@futrli/shared-services/app-core/setup/axios-api';
import { APIMiddlewareWrapper } from '@futrli/shared-services/redux-helpers/middlewares/api-middleware';
import { loadingRequests } from '@futrli/shared-services/redux-helpers/helpers/reducers';
import { normalised } from '@futrli/shared-services/redux-helpers/normalisation';
import { promiseMiddleware } from '@futrli/shared-services/redux-helpers/middlewares/promise-middleware';
import { applyMiddleware, combineReducers, compose, createStore, Reducer, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { clearQueryCacheOnAuthBoundary } from './clear-query-cache-on-auth-boundary';
import { StoreState } from './types';

/** Compose the store with the redux devtools extension if it is available */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const clearOnSignOut = (reducer: Reducer): Reducer => (state: unknown, action) => {
  if (action.type === SIGN_OUT.FULFILLED) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

/** Instance of a Redux Store. */
export const store: Store<StoreState> = createStore(
  combineReducers({
    intlReducer,
    loadingRequests,
    authReducers: clearOnSignOut(authReducers),
    normalised: clearOnSignOut(normalised)
  }),
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware,
      clearQueryCacheOnAuthBoundary,
      APIMiddlewareWrapper(axiosBaseInstance, appSigner, appAuthenticator),
      promiseMiddleware()
    )
  )
);
